import { SignUpFormData } from '@/contexts/forms/SignUp';
import { CustomSessionStorage } from '@/lib/storage/customSessionStorage';

const KEY = 'signup-form-data';

export const formDataSessionStorage = CustomSessionStorage<SignUpFormData>(KEY);
